import { render, staticRenderFns } from "./RFP.vue?vue&type=template&id=4d63f90b&"
import script from "./RFP.vue?vue&type=script&lang=js&"
export * from "./RFP.vue?vue&type=script&lang=js&"
import style0 from "./RFP.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports